import { IApiRequestConfig } from '../api.types';
import { IMeetingParticipantsUpdateForm, IMeetingSearchParams } from '../../resource/meeting/meeting.types';
import { ISession } from '../../resource/session/session.types';
import { IUser } from '../../resource/user/user.types';
import {
  IMeetingSimple,
  IMeetingSimpleCreate,
  IMeetingSimpleUpdate,
} from '../../resource/meeting-simple/meeting-simple.types';
import { IMeetingFolder } from '../../resource/meeting-shortcuts/meeting-shortcuts.types';
import { IQueryParams } from '../../page/page-storage/meeting-archive/meeting-archive.types';

export const getMeetingSimpleApi = (params?: IMeetingSearchParams): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'getMeetingsSimple',
  uri: 'json',
  action: 'getMeetingsSimple',
  method: 'get',
  params: {
    ...params,
  },
});

export const getMeetingSimpleApiForAdmin = (): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'getMeetingsSimpleAdmin',
  uri: 'json',
  action: 'admin/meetings',
  method: 'get',
  v2: true,
});

export const createMeetingSimpleApi = (meeting: IMeetingSimpleCreate): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'createMeetingFromApi',
  uri: 'json',
  action: `meetings`,
  method: 'post',
  data: meeting,
  v2: true,
});

export const updateMeetingSimpleApi = (
  id: IMeetingSimple['id'],
  meeting: IMeetingSimpleUpdate,
): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'updateMeetingSimple',
  uri: 'json',
  action: `meetings/${id}`,
  method: 'patch',
  data: meeting,
  v2: true,
});

export const updateMeetingParticipantsApi = (
  meetingId: IMeetingSimple['id'],
  data: IMeetingParticipantsUpdateForm,
): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'updateMeetingParticipants',
  action: `meetings/${meetingId}`,
  method: 'patch',
  data,
  v2: true,
});
export const deleteMeetingApi = (meetingId: IMeetingSimple['id']): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'deleteMeeting',
  uri: 'json',
  action: `meetings/${meetingId}`,
  method: 'delete',
  v2: true,
});

export const fetchLiveSessions = (): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'fetchLiveSessions',
  uri: 'json',
  action: 'meetings/live-sessions',
  method: 'get',
  v2: true,
});

export const startMeetingSessionApi = (data: { id: IMeetingSimple['id'] }): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'startMeetingSession',
  uri: 'json',
  action: 'startMeetingSession',
  method: 'post',
  params: { ...data },
});

export const finishMeetingSessionApi = (endSession: {
  sessionId: ISession['id'];
  cancelled: boolean;
}): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'finishMeetingSession',
  uri: 'json',
  action: 'finishMeetingSession',
  method: 'post',
  data: endSession,
});

export const joinMeetingApi = (joined: { sessionId: ISession['id'] }): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'joinMeeting',
  uri: 'json',
  action: 'joinMeeting',
  method: 'post',
  data: joined,
});

export const setFolderForMeeting = (
  meetingId: IMeetingSimple['id'],
  folderId: IMeetingFolder['id'],
): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'setFolderForMeeting',
  uri: 'json',
  action: `meetings/${meetingId}/folder`,
  method: 'patch',
  data: folderId,
  v2: true,
});

export const getMeetingArchivesApi = (
  meetingId: IMeetingSimple['id'],
  queryParams: IQueryParams,
): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'getMeetingArchives',
  uri: 'json',
  action: `meetings/${meetingId}/archives`,
  method: 'get',
  v2: true,
  params: {
    ...queryParams,
  },
});
